import { render, staticRenderFns } from "./FinishDesktopSvg.vue?vue&type=template&id=40f499c2&"
import script from "./FinishDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./FinishDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports